import { tracking } from '@iwoca/frontend-tracking-library';
import { IconInfoCircleOutline } from '@iwoca/icons';
import { AlertBox, ContentSwitcher } from '@iwoca/orion';
import { clsx } from 'clsx';

import VATReturns from './VATReturns';
import styles from './VATReturnsSwitch.module.css';
import { TOfferDataRequirement } from '../../../../../types';
import { getAmplitudeDefaultEventProperties } from '../../../../../utils/amplitudeEvents';
import { TVatSwitchStatus, TVatUploadStatus } from '../../TradingHistoryUK';
import thstyles from '../../TradingHistoryUK.module.css';

type TProps = {
  documentRequirements: TOfferDataRequirement['actions'];
  isSubmitted: boolean;
  setSwitchStatus: (status: TVatSwitchStatus) => void;
  switchStatus: TVatSwitchStatus;
  setUploadStatus: (status: TVatUploadStatus) => void;
  uploadStatus: TVatUploadStatus;
};

export const VATReturnsSwitch = ({
  documentRequirements,
  isSubmitted,
  setSwitchStatus,
  switchStatus,
  setUploadStatus,
  uploadStatus,
}: TProps) => {
  const vatReturnsRequirement = documentRequirements.find(
    (requirement) => requirement.type === 'vat_return',
  );

  const quantifier = vatReturnsRequirement
    ? vatReturnsRequirement.quantifier.value
    : 0;

  const isOptional = vatReturnsRequirement
    ? vatReturnsRequirement.is_optional
    : true;

  return (
    <>
      {isOptional !== false && (
        <div
          className={clsx(styles.VATAccount, styles.VATAccountSwitch)}
          data-testid="vat-statement-question"
        >
          <div className={thstyles.headerSection}>
            <h3 className={thstyles.requiredTitle}>
              Is your business VAT registered?
            </h3>
          </div>
          <div
            className={clsx(
              styles.descriptionContainer,
              styles.vatDescriptionContainer,
            )}
          >
            <ContentSwitcher
              value={switchStatus}
              wrapperClassName={styles.vatSwitchContainer}
              className={styles.vatSwitch}
            >
              <ContentSwitcher.Button
                id="yes"
                setSelected={() => {
                  tracking.ampli.toggle({
                    ...getAmplitudeDefaultEventProperties(),
                    optionLabel: 'yes',
                  });

                  setSwitchStatus('yes');
                }}
                className={clsx(
                  styles.vatSwitchButton,
                  switchStatus === 'yes' && styles.boldWeight,
                )}
              >
                Yes
              </ContentSwitcher.Button>
              <ContentSwitcher.Button
                id="no"
                setSelected={() => {
                  tracking.ampli.toggle({
                    ...getAmplitudeDefaultEventProperties(),
                    optionLabel: 'no',
                  });

                  setSwitchStatus('no');
                }}
                className={clsx(
                  styles.vatSwitchButton,
                  switchStatus === 'no' && styles.boldWeight,
                )}
              >
                No
              </ContentSwitcher.Button>
            </ContentSwitcher>
            <div
              className={clsx(styles.alertAnimation, {
                [styles.infoAnimateIn]: switchStatus === 'no',
              })}
            >
              <AlertBox
                data-testid="vat-warning"
                variant="connect"
                className={clsx(styles.infoAlert)}
              >
                <IconInfoCircleOutline width={25} height={20} />
                <p>
                  <strong>Important - </strong> selecting the wrong option will
                  delay your application.
                </p>
              </AlertBox>
            </div>
          </div>
        </div>
      )}
      <VATReturns
        isOptional={isOptional}
        quantifier={quantifier}
        isSubmitted={isSubmitted}
        disabled={switchStatus === 'no'}
        uploadStatus={uploadStatus}
        setUploadStatus={setUploadStatus}
      />
    </>
  );
};
